

















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ExtendsImageInspectVO } from "@/model/ExtendsImage";
import ExtendsImageContent from "@/components/ExtendsImageContent.vue";

@Component({
  components: { 
    ExtendsImageContent
  }
})
export default class ExtendsImageDialog extends Vue {
  @Prop({ default: null }) extendsImageInspect: ExtendsImageInspectVO;
  @Prop({ default: null }) extendsImageWorkList: ExtendsImageInspectVO[];
  @Prop({ default: 0 }) extendsImageWorkListIndex: number;
  @Prop({ default: false }) visible: boolean;

  localVisible: boolean = false;

  $refs!: {
    extendsImageContent: ExtendsImageContent;
  };

  created() {
  }

  @Watch('visible')
  onVisibleChanged(val: boolean) {
    this.localVisible = val;
    if (this.localVisible && this.$refs.extendsImageContent) {
      this.$refs.extendsImageContent.onDialogOpen(this.extendsImageInspect
        , this.extendsImageWorkList, this.extendsImageWorkListIndex);
    }
  }

  onClose() {
    this.localVisible = false;
    this.$emit('update:visible', false);
  }

}
